module.exports = __webpack_public_path__ + "img/Richard Shelby.7f95ed48.jpg";